<template>
    <div class="histoty-view">
        <el-tabs v-model="queryList.probe" type="card" @tab-click="handleClick">
            <el-tab-pane v-for="item in tabArray" :key="item.name" :label="item.content" :name="item.name"> </el-tab-pane>
        </el-tabs>
        <div style="height:250px;width:100%;margin-top: -35px;" v-loading="loading">
            <LineEchart v-if="chartData.data.length > 0" :chartData="chartData" :unitText="unitText" :yText="yText"
                height="250px" />
            <el-empty style="margin-top:-20px" v-else :description="$t('integration.no_data_temporarily')"></el-empty>
        </div>
        <!-- 最值 -->
        <div class="min-max-val">
            <span>{{ $t('integration.current_value') }}：{{ evalValue.curVal }}{{ unitText }}</span>
            <span>{{ $t('integration.maximum') }}：{{ evalValue.maxVal }}{{ unitText }}</span>
            <span>{{ $t('integration.minimum_value') }}：{{ evalValue.minVal }}{{ unitText }}</span>
            <span>{{ $t('integration.average_value') }}：{{ evalValue.avgVal }}{{ unitText }}</span>
        </div>
        <!-- 表格 -->
        <TableCom v-bind="$attrs" :tableData="tableData" :unitText="unitText" :total="total" @getListFn="pageFn" />
    </div>
</template>

<script>
import { probeHisotry } from '@/api/modules/carrier.js';
import LineEchart from '@/components/echart/lineEchart.vue';
import TableCom from './table/Index.vue';
import bus from '@/utils/bus';
export default {
    props: ['form', 'sensorObj', 'defaultTabs', 'carrierInfo'],
    components: {
        LineEchart,
        TableCom
    },
    watch: {
        sensorObj(newVal) {
            this.tabArray = [...this.defaultTabs];
            this.queryList.probe = this.tabArray[0].name;
            this.queryList.token = '';
            this.queryList.iDisplayStart = 0;
            this.queryList.iDisplayLength = 5;
            this.chartData = {
                data: [],
                rangeData: []
            };

            let unit = this.queryList.probe === 'volt' ? 'batt' : this.queryList.probe;
            if (newVal['probeValue'] && newVal['probeValue'][unit] && newVal['probeValue'][unit].val) {
                this.evalValue.curVal = newVal['probeValue'][unit].val;
            } else {
                this.evalValue.curVal = '--';
            }
            if (!this.form['start'] || !this.form['end']) return this.$message.warning($t('integration.time_cannot_be_empty'));
            this.queryList.carrierId = this.carrierInfo.id;
            this.queryList.code = newVal.carrierDeviceCode;


            this.queryList.from = this.form['start'];
            this.queryList.to = this.form['end'];
            this.getListFn(this.queryList);
        }
    },
    data() {
        return {
            tabArray: [
                {
                    content: $t('integration.temperature'),
                    name: 'temp'
                }
            ],
            queryList: {
                iDisplayLength: 5,
                iDisplayStart: 0,
                block: 1,
                dataSort: 0,
                pageSort: 1,
                from: null,
                to: null,
                token: null,
                probe: 'temp',
                devCatalog: 0,
                carrierId: null,
                code: '',
            },
            loading: false,
            evalValue: {
                curVal: '',
                maxVal: '',
                minVal: '',
                avgVal: ''
            },
            tableData: [],
            total: 0,
            unitText: '',
            yText: 'lqi',
            chartData: {
                data: [],
                rangeData: []
            }
        };
    },
    mounted() {
        bus.$on('dataValFn', val => {

            if (val.length > 0) {
                this.tabArray = val;
                this.queryList.probe = val[0].name;
            } else {
                this.tabArray = [];
            }
        });
    },
    beforeDestroy() {
        bus.$off('dataValFn');
    },
    methods: {
        unitVal() {
            this.unitText = '';
            this.yText = 'lqi';
            switch (this.queryList.probe) {
                case 'rssi':
                    return (this.unitText = 'rssi(dBm)'), (this.yText = 'rssi(dBm)');
                case 'volt':
                    return (this.unitText = 'V'), (this.yText = 'volt(V)');
                default:
                    return (
                        (this.unitText = this.unit[this.queryList.probe].name),
                        (this.yText = this.queryList.probe === 'temp' ? `温度(${this.unit[this.queryList.probe].name})` : `湿度(${this.unit[this.queryList.probe].name})`)
                    );
            }
        },
        getD(starDate, endDate) {
            // 默认90天
            var thisMothDays = 1000 * 3600 * 24 * 90;
            if (endDate - starDate > thisMothDays) {
                return true;
            } else {
                return false;
            }
        },
        getListFn(query) {
            this.loading = true;
            let flag = this.getD(this.$dateParseTime(query.from), this.$dateParseTime(query.to));
            if (flag) {
                query.block = 0;
            } else {
                query.block = 1;
            }
            probeHisotry(query)
                .then(({ result }) => {
                    if (result && result.ok === 1) {
                        this.loading = false;
                        this.evalValue.avgVal = result['avgVal'] || '--';
                        this.evalValue.maxVal = result['maxVal'] || '--';
                        this.evalValue.minVal = result['minVal'] || '--';
                        this.total = result.page.pageInfo.total || 0;
                        this.tableData = result.page.result;
                        if (this.chartData.data.length === 0) {
                            if (result.data && result.data.length > 0) {
                                result.data.forEach(item => {
                                    this.chartData.data.push({
                                        value: [this.$timetransition(item.collectTime), item.val],
                                        name: this.$timetransition(item.collectTime),
                                        max: item.max,
                                        min: item.min
                                    });
                                });
                                this.chartData.rangeData = result.rangeData.map(item => {
                                    return [
                                        {
                                            xAxis: this.$timetransition(item.minCollectTime),
                                            yAxis: item.minVal
                                        },
                                        {
                                            xAxis: this.$timetransition(item.maxCollectTime),
                                            yAxis: item.maxVal
                                        }
                                    ];
                                });
                            }
                        }
                    } else {
                        setTimeout(() => {
                            this.queryList.token = result.token;
                            this.getListFn(query);
                        }, 1000);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
            this.unitVal();
        },
        pageFn(query) {
            this.queryList.iDisplayStart = query.iDisplayStart;
            this.queryList.iDisplayLength = query.iDisplayLength;
            this.getListFn(this.queryList);
        },
        handleClick() {
            this.queryList.token = '';
            this.chartData = {
                data: [],
                rangeData: []
            };
            let unit = this.queryList.probe === 'volt' ? 'batt' : this.queryList.probe;
            const newValue = this.sensorObj['probeValue'];
            if (newValue[unit] && newValue[unit].val) {
                this.evalValue.curVal = newValue[unit].val;
            } else {
                this.evalValue.curVal = '--';
            }
            this.getListFn(this.queryList);
        }
    }
};
</script>

<style lang="scss" scoped>
.histoty-view {
    height: 100%;
    flex: 1;
    padding: 5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .min-max-val {
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        width: 100%;
        border-radius: 2px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        margin-bottom: 5px;

        span {
            margin-right: 15px;
        }
    }
}
</style>
